import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card, CardSubmitEvent } from '@/shared/components/cardRenderer';
import { InstalledApp } from '@/features/apps/shared/models';
import { AppCard } from '@/features/apps/shared/models/appCard';
import { PropType } from 'vue';

interface CardListItem {
  type: string;
  id: string;
  title: string;
  subtitle?: string;
  action?: { type: string };
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CapableAppSelection',
  props: {
  capableApps: {
    type: Array as PropType<InstalledApp[]>,
    required: true,
  },
},
  emits: ["selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function getCards(): Card[] {
  return [
    {
      id: 'homescreenAppSelection',
      content: createCardContent(),
    },
  ];
}

function cardSubmit(e: CardSubmitEvent) {
  const installedApp = props.capableApps.find((app) => app.installedAppId === e.componentId);
  if (installedApp) {
    emit('selected', installedApp);
  }
}

function createCardContent(): AppCard {
  const content: AppCard = {
    components: [],
  };
  if (props.capableApps && props.capableApps.length) {
    const items = props.capableApps.map((app) => createListItem(app.installedAppId, app.name, app.description || ''));
    content.components.push({
      type: 'list',
      disabled: false,
      items,
    });
  } else {
    createError().map((x) => content.components.push(x));
  }
  return content;
}

function createListItem(id: string, title: string, subtitle: string): CardListItem {
  return {
    type: 'item',
    id,
    title,
    subtitle: subtitle || 'Private app',
    action: {
      type: 'submit',
    },
  };
}

function createError() {
  return [
    {
      type: 'text',
      text: '# No relevant apps installed',
    },
    {
      type: 'spacer',
      size: 's',
    },
    {
      type: 'text',
      text: 'Visit the App Store to install existing apps, or create your own private app.',
    },
  ];
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardRenderer, {
    colour: '#062B80',
    location: 'embedded',
    cards: getCards(),
    onSubmit: _cache[0] || (_cache[0] = ($event: any) => (cardSubmit($event)))
  }, null, 8, ["cards"]))
}
}

})